/** @jsx jsx */
import { jsx } from '@emotion/react';

import { Typography2, useTheme } from '@coursera/cds-core';

import _t from 'i18n!nls/program-skills-objectives';

const LevelInformation = ({
  levelName,
  minValue,
  maxValue,
}: {
  levelName: string;
  minValue: number;
  maxValue: number;
}) => {
  const theme = useTheme();
  return (
    <li
      aria-label={_t('Between #{minValue} and #{maxValue} it is #{levelName} level.', {
        levelName,
        minValue,
        maxValue,
      })}
      css={{
        width: '100%',
        display: 'flex',
      }}
    >
      <Typography2
        css={{ flexBasis: 120, textAlign: 'left' }}
        variant="subtitleMedium"
        color="supportText"
        component="p"
      >
        {levelName}
      </Typography2>
      <div css={{ height: 18, flexGrow: 1, borderBottom: `1.5px dashed ${theme.palette.gray[500]}` }} />
      <Typography2
        css={{ flexBasis: 80, textAlign: 'right' }}
        variant="subtitleMedium"
        color="supportText"
        component="p"
      >
        {minValue}-{maxValue}
      </Typography2>
    </li>
  );
};

export default LevelInformation;
